module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_60y_n.b58bc9ad.csv";